// @flow @jsx h
import { Component, h } from 'preact'
import { Video } from '@nrk/dh-feature-components'

import styles from './index.css'
import type { VideoType } from '../../domain'
import { toVideoSrc } from '../../../common'

type Props = {
  playing: boolean,
  video: VideoType,
  title: string,
  caption: string
}

export class LevendeStillbildeBlokk extends Component<Props> {
  render () {
    const { playing, video, title, caption } = this.props
    const vid = toVideoSrc(video)

    return <div class={styles.levendeStillbildeBlokk}>
      <figure class={styles.levendeStillbildeBlokk__video}>
        <Video
          playing={playing}
          title={title}
          loop
          muted
          playsInline
          disableRemotePlayback
          poster={vid.poster}
          sources={vid.sources}
          preload='none'
          className={''} />
        {caption && <figcaption>{caption}</figcaption>}
      </figure>
    </div>
  }
}
